<script>
import Layout from "../../layouts/auth";
import { login } from "../../../api/services/user.service";
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import { authMethods } from "@/state/helpers";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: null,
      password: null,
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {},
  methods: {
    ...authMethods,
    async tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        return login(this.email, this.password)
          .then((token) => {
            this.tryingToLogIn = false;
            this.isAuthError = false;

            // Redirect to the originally requested page, or to the home page
            this.logIn({ token: token.accessToken, expire: token.expiresIn });
            this.$router.push(
              this.$route.query.redirectFrom || { name: "default" }
            );
          })
          .catch(() => {
            this.tryingToLogIn = false;
            this.authError = this.$i18n.t("auth.login.loginError");
            this.isAuthError = true;
          });
      }
    },
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-light">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">{{ $t("auth.login.welcome") }}</h5>
                  <p>{{ $t("auth.login.welcomeSupport") }}</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/auth-background.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img
                      src="@/assets/images/ms-sissi-logo.png"
                      alt
                      height="75"
                    />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                id="input-group-1"
                :label="this.$i18n.t('auth.login.emailLabel')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  :placeholder="this.$i18n.t('auth.login.emailPlaceholder')"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">{{
                    $t("auth.login.emailRequired")
                  }}</span>
                  <span v-if="!$v.email.email">{{
                    $t("auth.login.emailNotValid")
                  }}</span>
                </div>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                :label="this.$i18n.t('auth.login.passwordLabel')"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  :placeholder="this.$i18n.t('auth.login.passwordPlaceholder')"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  {{ $t("auth.login.passowrdRequired") }}
                </div>
              </b-form-group>
              <div class="mt-4">
                <b-button type="submit" variant="success" class="btn-block">{{
                  $t("auth.login.loginButton")
                }}</b-button>
              </div>
              <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock mr-1"></i>
                  {{ $t("auth.login.forgetPassword") }}
                </router-link>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} Ms-Sissi. Made with
            <i class="mdi mdi-heart text-danger"></i> by AusriLabs
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
